import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import Textarea from 'Components/Atoms/Textarea/Textarea';

export default function RHFTextarea({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => <Textarea {...field} error={error?.message} {...other} />}
        />
    );
}

RHFTextarea.propTypes = {
    name: PropTypes.string,
};
